import { createContext, useContext, useEffect, useState } from "react";
import { _BoardColumns, _BoardColumnStatuses, _single, _WorkActivity } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";

type Props = {
    sprintId: number;
    GroupID?: number;
    IDAccount?: number;
    children: React.ReactNode;
};

type BoardManagerContextType = {
    columns: any[];
    activities: any[];
    relations: any[];

    sprintId: number;
    GroupID?: number;
    IDAccount?: number;

    updateStateActivity: (
        idTarea: number,
        newStatus: number,
        idAccount?: number
    ) => void;

    updateWorkActivity: (bean: any, onFunction?: Function) => void;

    reload: () => void;

    assingWorkActivity: (
        idWorkActivity: number,
        idEmployee: number,
        onFunction?: Function
    ) => void;
};

const BoardManagerContext = createContext<BoardManagerContextType | null>(null);

export const BoardManagerProvider = ({ sprintId, GroupID, IDAccount, children }: Props) => {

    const { instance: activityInstance } = useDataBean(_WorkActivity);
    const { instance: columnInstance } = useDataBean(_BoardColumns);
    const { instance: columnRelations } = useDataBean(_BoardColumnStatuses);

    const [columns, setColumns] = useState<any[]>([]);
    const [activities, setActivities] = useState<any[]>([]);
    const [relations, setRelations] = useState<any[]>([]);

    useEffect(() => {
        loadColumns();
        loadActivities();
        loadRelations();
    }, [sprintId, GroupID]);

    const loadColumns = () => {
        columnInstance.getBoardColumnsCatalogPorPropiedades({ State: 1 }, null)
            .then(setColumns)
            .catch(err => toast.error(err));
    };

    const loadActivities = () => {
        activityInstance.getWorkActivityRender(null, null, {
            IDSprint: sprintId,
            IDWorkActivityGroup: GroupID,
            IDEmployee: IDAccount,
            State: 1
        }).then(resp => setActivities(resp.List))
            .catch(err => toast.error(err));
    };

    const loadRelations = () => {
        columnRelations.getBoardColumnStatusesRender({ IsActive: 1 })
            .then(resp => setRelations(resp.List))
            .catch(err => toast.error(err));
    };

    const updateStateActivity = (idTarea: number, newStatus: number, idAccount?: number) => {
        activityInstance.changeStateWorkActivityStatuses(
            idTarea,
            newStatus,
            idAccount ?? _single.getAccountID()
        ).then(() => {
            loadActivities();
        }).catch((e) => {
            console.log(e)
            toast.error("No se pudo actualizar la tarea");
        });
    };

    const updateWorkActivity = (obj: any, onFunction?: () => void) => {
        activityInstance.updateWorkActivity(obj).then(
            (resp) => {
                console.log(resp);
                loadActivities();
                onFunction?.();
            }
        ).catch((e) => {
            console.log(e)
            if (obj.IDWorkActivity) {
                toast.error("No se pudo crear la tarea");
            } else {
                toast.error("No se pudo actualizar la tarea");
            }
        })
    }

    const assingWorkActivity = (idWorkActivity: number, idEmployee: number, onFunction?: Function) => {
        activityInstance.assingIDEmployeeToWorkActivity(idWorkActivity, idEmployee).then(
            () => {
                onFunction?.();
                loadActivities();
            }
        ).catch((e) => {
            console.log(e)
            toast.error("No se pudo actualizar la tarea");
        })
    }

    return (
        <BoardManagerContext.Provider
            value={{
                columns,
                activities,
                relations,

                sprintId,
                GroupID,
                IDAccount,

                updateWorkActivity,
                updateStateActivity,
                reload: loadActivities,
                assingWorkActivity,
            }}
        >
            {children}
        </BoardManagerContext.Provider>
    );
}

export const useBoardManager = () => {
    const context = useContext(BoardManagerContext);

    if (!context) {
        throw new Error("useBoardManager debe usarse dentro de BoardManagerProvider");
    }

    return context;
};